<template>
    <div class="card-box">
        <div class="card-title">
            <span class="card-title-text">{{ card.name || '未命名卡片' }}</span>
            <el-icon class="card-zoom" title="查看详情" @click="dialogVisible = true"><Search /></el-icon>
        </div>
        <div class="card-body">
            <el-table v-if="rows.length" :data="rows" size="small" height="200">
                <el-table-column v-for="col in columns" :key="col.prop" :prop="col.prop" :label="col.label" show-overflow-tooltip />
            </el-table>
            <div v-else class="card-placeholder">暂无数据</div>
        </div>

        <el-dialog v-model="dialogVisible" :title="card.name || '未命名卡片'" width="min(900px, 92vw)" :close-on-click-modal="false">
            <el-table v-if="rows.length" :data="rows" size="small" max-height="60vh">
                <el-table-column v-for="col in columns" :key="col.prop" :prop="col.prop" :label="col.label" :min-width="columnWidth(col)" show-overflow-tooltip />
            </el-table>
            <el-empty v-else description="暂无数据" />
        </el-dialog>
    </div>
</template>

<script>
import { Search } from '@element-plus/icons';
import request from '@/utils/request';

export default {
    name: 'CardTable',
    components: { Search },
    props: {
        card: { type: Object, required: true },
        viewId: { type: String, default: '' },
        sectionIndex: { type: Number, default: -1 },
        cardIndex: { type: Number, default: -1 }
    },
    data() {
        return {
            rows: [],
            columns: [],
            dialogVisible: false
        };
    },
    mounted() {
        this.loadData();
    },
    methods: {
        loadData() {
            if (!this.viewId || this.sectionIndex < 0 || this.cardIndex < 0) {
                return;
            }
            return request({
                url: '/dataview/getCardData',
                method: 'post',
                data: {
                    id: this.viewId,
                    sectionIndex: this.sectionIndex,
                    cardIndex: this.cardIndex
                }
            }).then(res => {
                if (res.code === 0) {
                    this.parseData(res.meta.data);
                }
            });
        },
        parseData(data) {
            if (!data) {
                this.columns = [];
                this.rows = [];
                return;
            }
            const configuredColumns = this.parseColumnConfig();
            // 数组：每项为一行对象，列名取首行对象的 key
            if (Array.isArray(data)) {
                this.rows = data;
                if (configuredColumns) {
                    this.columns = configuredColumns;
                } else if (data.length > 0 && data[0] && typeof data[0] === 'object') {
                    this.columns = Object.keys(data[0]).map(k => ({ prop: k, label: k }));
                } else {
                    this.columns = [];
                }
                return;
            }
            // 对象：支持 { columns: [...], rows: [...] } 结构
            if (typeof data === 'object') {
                if (configuredColumns) {
                    this.columns = configuredColumns;
                } else {
                    const rawColumns = data.columns || [];
                    this.columns = rawColumns.map(c => (typeof c === 'string' ? { prop: c, label: c } : c));
                }
                this.rows = data.rows || [];
            }
        },
        // 解析参数中的 column 配置：createTime:创建时间,machineId:设备ID,freePhysicalMemorySize
        // 有冒号时冒号后为展示名称，无冒号时用列名作为展示名称；按配置顺序展示
        parseColumnConfig() {
            const params = this.card.params || {};
            const column = params.column;
            if (typeof column !== 'string' || !column.trim()) {
                return null;
            }
            return column.split(',')
                .map(s => s.trim())
                .filter(Boolean)
                .map(token => {
                    const idx = token.indexOf(':');
                    if (idx >= 0) {
                        const prop = token.slice(0, idx).trim();
                        const label = token.slice(idx + 1).trim();
                        return { prop, label: label || prop };
                    }
                    return { prop: token, label: token };
                })
                .filter(c => c.prop);
        },
        columnWidth(col) {
            const measure = (s) => {
                let len = 0;
                for (const ch of s) {
                    len += /[\u4e00-\u9fff]/.test(ch) ? 2 : 1;
                }
                return len;
            };
            let maxLen = measure(String(col.label || ''));
            this.rows.forEach(row => {
                const v = row[col.prop];
                if (v != null) {
                    const len = measure(String(v));
                    if (len > maxLen) maxLen = len;
                }
            });
            // 每单位约 7px，加左右内边距，限制在 80~320px
            return Math.min(320, Math.max(80, maxLen * 7 + 28));
        }
    }
};
</script>

<style scoped>
.card-box {
    border: 1px solid #e4e7ed;
    border-radius: 8px;
    background: #fff;
    overflow: hidden;
}
.card-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 14px;
    font-size: 14px;
    font-weight: bold;
    border-bottom: 1px solid #f0f2f5;
    background: #fafafa;
    color: #303133;
}
.card-title-text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.card-zoom {
    cursor: pointer;
    color: #909399;
    font-size: 16px;
    flex-shrink: 0;
}
.card-zoom:hover {
    color: #409eff;
}
.card-body {
    height: 200px;
    padding: 0;
}
.card-placeholder {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    color: #909399;
    font-size: 13px;
    border: 1px dashed #dcdfe6;
    border-radius: 6px;
}
</style>
